export default {
    newPageCreateFile: "Datei wird erstellt",
    globalConfirm: "Sichern",
    globalCancel: "Abbrechen",
    globalStyle: "Style",
    globalColor: "Farbe",
    globalLine: "Linie",
};
